<template>
	<div class="col" v-for="location in locations" :key="location.officeName">
		<article class="card mb-3 location-card">
			<div class="card-body">
				<div class="card-text" v-html="location.officeAddress"></div>
			</div>
		</article>
	</div>
</template>

<script setup>
const { locationsData } = defineProps(['locationsData']);
const locations = locationsData.items.sort((p1, p2) =>
		Number.parseInt(p1.order, 10) - Number.parseInt(p2.order, 10));
</script>
